import onChange from 'on-change';
import selectors from '../../globals/selectors';
import View from './View';

export default (selector, initialState) => {
	const state = {
		isOptionsVisible: false,
		selected: null,
		options: [],
		ui: {
			// TODO: need implement render
			needRenderOptions: false,
		},
		...initialState,

		get selectedOptionText() {
			if (this.selected === null) {
				return null;
			}

			const selectedOption = this.options.find(
				(option) => option.value === this.selected
			);
			return selectedOption.text;
		},
	};

	const element = document.querySelector(selector);

	const optionEls = element?.querySelectorAll(selectors.select.option);
	if (optionEls === null || optionEls === undefined)
		return;
	const hasOptionEls = optionEls.length !== 0;

	if (hasOptionEls) {
		state.options = View.parseOptionsFromEls(optionEls);
	}

	const view = new View(element);

	function onChangeCb(path, value) {
		switch (path) {
			case 'isOptionsVisible':
				view.toggleOptionsVisibility(value);
				break;
			case 'selected':
				view.render(this);
				break;
			default:
				throw new Error(`unknown mutation - ${path}: ${value}`);
		}
	}

	const watchedState = onChange(state, onChangeCb);

	const handleSelectedOptionClick = () => {
		watchedState.isOptionsVisible = !watchedState.isOptionsVisible;
	};

	const handleOptionClick = (ev) => {
		const optionEl = ev.target.closest(selectors.select.option);
		const optionValue = optionEl.dataset.selectOption;

		watchedState.isOptionsVisible = false;
		watchedState.selected = optionValue;
	};

	const handleBodyClick = (ev) => {
		const currentSelectId = element.dataset.select;
		const isClickedAtSelect =
			ev.target.closest(`[data-select=${currentSelectId}]`) !== null;
		if (isClickedAtSelect) {
			return;
		}
		watchedState.isOptionsVisible = false;
	};

	view.init({ handleSelectedOptionClick, handleBodyClick, handleOptionClick });
};
